import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const countriesGet = () =>
    axios.get(`${apiUrl}countries`);

export const countriesGetById = (countryId) =>
    axios.get(`${apiUrl}countries/${countryId}`);

export const provincesGetCountryById = (countryId) =>
    axios.get(`${apiUrl}countries/${countryId}/provinces`);

export const provincesGetById = (provinceId) =>
    axios.get(`${apiUrl}provinces/${provinceId}`);

export const citiesGetByProvinceId = (provinceId) =>
    axios.get(`${apiUrl}provinces/${provinceId}/cities`);

export const citiesGetById = (cityId) =>
    axios.get(`${apiUrl}cities/${cityId}`);

export const citiesUpdateById = (cityId, data) =>
    axios.put(`${apiUrl}cities/${cityId}`, data);

/**
 * Create new city
 * @param {Object} data = { name, inactive, provinceId, isTravelRegion, travelCharge }
 * @returns {Object}
 */
export const citiesInsert = (data) =>
    axios.post(`${apiUrl}cities`, data);

export const citiesDeleteById = (cityId) =>
    axios.delete(`${apiUrl}cities/${cityId}`);
